module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Write another review","expected_reward":"Up to {0} can be earned"}}')
  delete Component.options._Ctor
}
